import { Box, Button } from "@material-ui/core";
import React, {
  ChangeEvent,
  Dispatch,
  Fragment,
  ReactNode,
  SetStateAction,
  useRef,
  useState,
} from "react";
import style from "../../../social-network/social-network.module.scss";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import { uploadContent } from "adapters";
import { UploadType } from "store/url-builder";
import { toast } from "react-toastify";

import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { uploadFile } from "adapters/public-card";
import { useParams } from "react-router-dom";

export interface UploadVideoButtonProps {
  onUpload(video: UploadType): void;
  setDisableSave?: Dispatch<SetStateAction<boolean>>;
}

export const UploadVideoButton = ({
  onUpload,
  setDisableSave,
}: UploadVideoButtonProps) => {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  const inputRef = useRef<HTMLInputElement>(null);

  const { cardId }: any = useParams();

  const handleVideoSelect = async (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files === null) return;

    if (e.target.files[0].size / 1e6 > 30) {
      clearFileInput();
      return toast.error("This file exceeds the maximum upload size.");
    }

    setLoading(true);
    if (setDisableSave) setDisableSave(true);
    const videoFile = e.target.files[0];

    // create dummy file
    const _file = new File([""], videoFile.name, {
      type: videoFile.type,
    });

    await uploadContent(_file)
      .then(async ({ data }) => {
        if (!data.success) return;

        await uploadFile(cardId, videoFile, data, setProgress).then(
          ({ data }) => {
            if (!data.success) return;
            onUpload(data.data);
          }
        );
      })
      .finally(() => {
        setLoading(false);
        setProgress(0);
        if (setDisableSave) setDisableSave(false);
        clearFileInput();
      });
  };

  const clearFileInput = () => {
    if (inputRef.current) {
      inputRef.current!.type = "text";
      inputRef.current!.type = "file";
    }
  };

  return (
    <Box position="relative" height="20em">
      <Box sx={{ p: 3, fontStyle: "italic" }} style={{ opacity: 0.7 }}>
        Maximum video size is 30MB
      </Box>
      <input
        onChange={handleVideoSelect}
        style={{ display: "none" }}
        accept="video/*"
        id="video-upload"
        type="file"
        disabled={loading}
        ref={inputRef}
      />
      <label htmlFor="video-upload">
        <Button
          className={style.videoButton}
          component="span"
          disabled={loading}
        >
          {loading ? (
            <div style={{ height: 100, width: 100 }}>
              <CircularProgressbar
                value={progress}
                maxValue={100}
                text={`${progress}%`}
              />
            </div>
          ) : (
            <>
              <AttachFileIcon /> Attach Your Video
            </>
          )}
        </Button>
      </label>
    </Box>
  );
};
